/**
 * @author: lv.chen
 * @date: 2026/2/5
 * @desc: 年度榜单组件
 */
import React from 'react';
import classnames from 'classnames';
import { LANGUAGE_EN, LANGUAGE_CN } from '@home/_config/config';

import './YearlyPoster.scss';

import IMG_YEARLY_POSTER_EN from '@home/assets/img/yearly-poster/yearly-poster-en.png';
import IMG_YEARLY_POSTER_CN from '@home/assets/img/yearly-poster/yearly-poster-cn.png';

const yearlyPosterImgMap = {
  [LANGUAGE_EN]: IMG_YEARLY_POSTER_EN,
  [LANGUAGE_CN]: IMG_YEARLY_POSTER_CN,
};

// @ts-ignore
interface IYearlyPosterProps extends IBaseProps {
  locale: string;
}

const YearlyPoster: React.FC<IYearlyPosterProps> = (props) => {
  const { style, className, locale } = props;

  // @ts-ignore
  const yearlyPostImg = yearlyPosterImgMap[locale] ?? IMG_YEARLY_POSTER_EN;

  return (
    <div style={style} className={classnames('dbh-yearly-poster', className)}>
      <img className="dbh-yearly-poster__img" src={yearlyPostImg} alt="" />
    </div>
  );
};

export default YearlyPoster;
